import React from 'react';

// Loading spinner. `size` (number px) overrides the default 20px.
// Announces itself via role="status" + aria-label.
export default function Spinner({ label = 'Loading', size, className = '' }) {
  const style = size ? { width: size, height: size } : undefined;
  return (
    <span
      className={`ss-spinner ${className}`.trim()}
      style={style}
      role="status"
      aria-label={label}
    />
  );
}
